import { render, staticRenderFns } from "./ExpedientReminderNotesComponent.vue?vue&type=template&id=41a592ec&scoped=true"
import script from "./ExpedientReminderNotesComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpedientReminderNotesComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ExpedientReminderNotesComponent.vue?vue&type=style&index=0&id=41a592ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a592ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a592ec')) {
      api.createRecord('41a592ec', component.options)
    } else {
      api.reload('41a592ec', component.options)
    }
    module.hot.accept("./ExpedientReminderNotesComponent.vue?vue&type=template&id=41a592ec&scoped=true", function () {
      api.rerender('41a592ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientReminderNotes/ExpedientReminderNotesComponent.vue"
export default component.exports